import { H2, P1, P3 } from '../../../styles/FontStyles';
import { Flexed, SectionSeparator } from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';

import { USDT, formatUSDNoDecimals } from '../../../helpers/helperFunctions';

import { GridItem } from './Akasha.styled';

import { Button } from '../../../components/common/Button/Button';

interface NodePackageProps {
  hub: any;
  selectedHub: any;
  handleSelectPackage: any;
}

export const NodePackage = ({
  hub,
  selectedHub,
  handleSelectPackage
}: NodePackageProps) => {
  return (
    <GridItem selected={selectedHub?.id === hub?.id}>
      <img src={hub.image} style={{ width: '100%' }} />

      <div>
        <Flexed column center>
          <H2 color={colors.primary900} mb='4' mt='30'>
            {hub.name}
          </H2>
        </Flexed>
        <P1 mb='30' color={colors.primary900}>
          {formatUSDNoDecimals(hub.price)} {USDT}
        </P1>

        <Flexed between>
          <P1 mb='12' color={colors.neutral0}>
            Node ON
          </P1>
          <P1 color={colors.neutral0}>{hub.nodeOnPercentage}%</P1>
        </Flexed>

        <Flexed between>
          <P1 mb='12' color={colors.neutral0}>
            Node OFF
          </P1>
          <P1 color={colors.neutral0}>{hub.nodeOffPercentage}%</P1>
        </Flexed>

        <SectionSeparator />

        <P1 mb='15' left color={colors.neutral0}>
          Max. Deposit
        </P1>
        <P1 left color={colors.neutral0}>
          {formatUSDNoDecimals(hub.volumePoints)} USDT{' '}
        </P1>
        <P3 left color={colors.neutral0}>
          in ULX/AK1111
        </P3>
      </div>

      <Button
        w='100%'
        wSM='100%'
        mt='20'
        onClick={() => handleSelectPackage(hub)}>
        Buy {hub.name} Node
      </Button>
    </GridItem>
  );
};
